import { useEffect, useState } from "react"
import { Tooltip as ReactTooltip } from "react-tooltip"
import styled from "styled-components"

import { useLazyGetContractorUniversityUrlQuery } from "store/api/contractorsApi"
import { useAppSelector } from "store/hooks"
import SubscriptionPlan from "types/enums/SubscriptionPlan"
import { ReactComponent as IconKnowledgeCenter } from "assets/svg/knowledge-center-icon.svg"

import { isMobileDevice } from "utils/deviceDetection"

import localStyles from "./index.module.scss"

const KnowledgeIconWrapper = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
  align-items: center;
  margin-left: 10px;
  justify-content: center;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
    border-radius: 8px;
  }

  span {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    position: relative;
    cursor: pointer;
  }
`

export const UniversityIcon = () => {
  const userProfile = useAppSelector(state => state.user.userProfile)
  const current_subscription = userProfile?.contractor?.subscription_plan
  const hasEPlusPlan = current_subscription === SubscriptionPlan.E_PLUS
  const universityAccessible = hasEPlusPlan || userProfile?.contractor?.university_accessible || false

  const [triggerGetContractorUniversityUrl] = useLazyGetContractorUniversityUrlQuery()
  const [universityUrl, setUniversityUrl] = useState<string>("")
  const mobileDevice = isMobileDevice()

  const fetchUniversityUrl = async () => {
    const res = await triggerGetContractorUniversityUrl()
    if (res.data?.data) {
      setUniversityUrl(res.data?.data)
      return res.data?.data
    }
  }

  const handleOpenContractorUniversityUrl = async () => {
    const url = await fetchUniversityUrl()
    if (url) {
      window.open(url, "_blank", "noreferrer")
    }
  }

  useEffect(() => {
    if (mobileDevice && universityAccessible) {
      fetchUniversityUrl()
      const interval = setInterval(() => {
        fetchUniversityUrl()
      }, 86400)
      return () => clearInterval(interval)
    }
  }, [universityAccessible, mobileDevice])

  if (!universityAccessible) {
    return null
  }

  return (
    <KnowledgeIconWrapper>
      {mobileDevice ? (
        <a href={universityUrl} data-tooltip-id={"tooltip-knowledge-center"} target="_blank" rel="noreferrer">
          <IconKnowledgeCenter />
        </a>
      ) : (
        <span data-tooltip-id={"tooltip-knowledge-center"} onClick={handleOpenContractorUniversityUrl}>
          <IconKnowledgeCenter />
        </span>
      )}
      <ReactTooltip delayShow={500} className={localStyles.tooltip} id={"tooltip-knowledge-center"}>
        Contractors University
      </ReactTooltip>
    </KnowledgeIconWrapper>
  )
}
